import Axios from "axios";
import CryptoJS from "crypto-js";

export interface IClientEnv {
  NODE_ENV: string;
  SERVER_URL: string;
  AUTH_SERVER: string;
  MGR_SERVER: string;
  UCWORKS_VER: string;
  CLOUD_CONVERT_APIKEY: string;
  IS_PRIVATE_NETWORK: boolean;
  USE_DOC_SHARING: boolean;
  USE_SCREEN_SHARING: boolean;
  USE_SCREEN_SHOT: boolean;
  USE_RECORDING: boolean;
  USE_STT: boolean;
  USE_MEMO: boolean;
  USE_EXTERNAL_PARTICIPANT: boolean;
  FORCE_VIRTUAL_BG: boolean;
  MAX_DISPLAY_USERS_IN_GRID: number;
  ENABLE_NOISE_SUPPRESSION: boolean;
  ENABLE_ECHO_CANCELLATION: boolean;
  ENABLE_AUTO_GAIN_CONTROL: boolean;
}

export const getClientEnv = async (tenantId: string, issuer: string): Promise<IClientEnv> => {
  try {
    const url =
      process.env.NODE_ENV === "production"
        ? `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + window.location.port : ""}/client-env`
        : `${window.location.protocol}//${window.location.hostname}:3001/client-env`;

    const referrer = document.referrer.replaceAll("/test", "");

    console.log("########## getClientEnv url:", url);
    console.log("########## getClientEnv issuer:", issuer);
    console.log("########## getClientEnv referrer:", referrer);

    const axiosInstance = Axios.create({ timeout: 30000 });
    const response = await axiosInstance.post(url, { tenantId, issuer, referrer });

    const key = process.env.REACT_APP_CLIENT_ENV_KEY || "";
    const { env } = response.data;
    const bytes = CryptoJS.AES.decrypt(env, key);
    const res: IClientEnv = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    console.log("getClientEnv res", res);
    return res;
  } catch (e) {
    console.log("error from getClientEnv api", e);
    return {
      NODE_ENV: "",
      SERVER_URL: "",
      AUTH_SERVER: "",
      MGR_SERVER: "",
      UCWORKS_VER: "",
      CLOUD_CONVERT_APIKEY: "",
      IS_PRIVATE_NETWORK: false,
      USE_DOC_SHARING: true,
      USE_SCREEN_SHARING: true,
      USE_SCREEN_SHOT: true,
      USE_RECORDING: true,
      USE_STT: true,
      USE_MEMO: true,
      USE_EXTERNAL_PARTICIPANT: true,
      FORCE_VIRTUAL_BG: false,
      MAX_DISPLAY_USERS_IN_GRID: 30,
      ENABLE_NOISE_SUPPRESSION: false,
      ENABLE_ECHO_CANCELLATION: false,
      ENABLE_AUTO_GAIN_CONTROL: false,
    };
  }
};
